module.exports = __webpack_public_path__ + "static/media/goodday_scores.3573d6d3.png";